<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div>
          <div>
            <input class="form-control mb-3" type="text" placeholder="filter..." v-model="filter">
          </div>
          <div v-for="asset in filteredAssets" :key="asset._id">
            <div class="asset-wrapper">
              <div class="asset">
                <img width="100" :src="getDeletedPath(asset)" alt="">
              </div>
              <div class="details">
                <span class="details__category">{{ asset.category }}</span> {{ asset.description }}
              </div>
              <div class="action">
                <button @click="restoreAsset(asset)">restore</button>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      assets: [],
      restoredAsset: {},
      filter: ''
    }
  },

  computed: {
    filteredAssets () {
      if (this.filter) {
        return this.assets.filter(asset => asset.description.toLowerCase().includes(this.filter.toLowerCase()))
      }

      return this.assets
    }
  },

  created () {
    this.fetchDeletedAssets()
  },

  methods: {
    fetchDeletedAssets () {
      this.axios.get('assets/deleted').then((res) => {
        this.assets = res.data
      })
    },

    getDeletedPath (asset) {
      let pathArray = asset.thumbPath.split('.')
      pathArray.splice(-1, pathArray.length - 1)
      pathArray.push(asset._id, 'deleted')

      return this.$store.state.assetsPath + pathArray.join('.')
    },

    restoreAsset (asset) {
      this.axios.put('assets/restore/' + asset._id).then((res) => {
        this.restoredAsset = res.data

        this.fetchDeletedAssets()
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.asset-wrapper {
  align-items: center;
  display: flex;
  margin-bottom: 10px;
}

.asset {
  background-image: 
    linear-gradient(to right, rgba(230, 237, 245, 0.85), rgba(230, 237, 245, 0.85)), 
    linear-gradient(to right, #000 50%, #fff 50%), 
    linear-gradient(to bottom, #000 50%, #fff 50%);
  background-blend-mode: normal, difference, normal;
  background-size: 1em 1em;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
  width: 100px;
}

.details {
  margin: auto 8px;
  
  &__category {
    background: #e4e9f7;
    border-radius: 8px;
    padding: 2px 6px;
  }
}
</style>
